export enum StateTypeEnum {
    NoError = "NoError",
    AuthError = "AuthError"
}

type ErrorInfo = {
    timeStamp?: number; // Time stamp when the error was triggered
    error?: string; // Error code or messages
};

interface AccountAuthState {
    stateType: StateTypeEnum;
    errorData?: ErrorInfo;
    isReplacedInSession?: boolean; // True if the account was replaced in the session
}

export default AccountAuthState;
